import { TwitchIcon, YouTubeIcon, InstagramIcon, DiscordIcon } from '../icons/SocialIcons';
import { Heart } from 'lucide-react';
import {
  DISCORD_URL,
  INSTAGRAM_URL,
  TWITCH_URL,
  YOUTUBE_ASMR_URL,
  YOUTUBE_CERAMICA_URL,
} from '../../constants/social';

const links = [
  { label: 'Twitch', url: process.env.REACT_APP_TWITCH_CHANNEL || TWITCH_URL, icon: <TwitchIcon className="w-4 h-4" /> },
  { label: 'Instagram', url: INSTAGRAM_URL, icon: <InstagramIcon className="w-4 h-4" /> },
  { label: 'CeramiCalmaASMR', url: YOUTUBE_CERAMICA_URL, icon: <YouTubeIcon className="w-4 h-4" /> },
  { label: 'EugenialASMR', url: YOUTUBE_ASMR_URL, icon: <YouTubeIcon className="w-4 h-4" /> },
  { label: 'Discord', url: DISCORD_URL, icon: <DiscordIcon className="w-4 h-4" /> },
];

export default function Footer() {
  return (
    <footer className="bg-[#05060f] border-t border-white/5 py-12 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col items-center text-center gap-6">
          <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-rose-200 to-sky-200">
            EuGe_NiAL
          </h3>

          <nav className="flex flex-wrap justify-center gap-x-6 gap-y-3">
            {links.map((l) => (
              <a
                key={l.label}
                href={l.url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-rose-300 transition-colors"
              >
                {l.icon}
                {l.label}
              </a>
            ))}
          </nav>

          <div className="w-px h-8 bg-gradient-to-b from-white/10 to-transparent" />

          <p className="inline-flex items-center gap-1.5 text-sm text-slate-500">
            Hecho con <Heart className="w-3.5 h-3.5 text-rose-400 fill-rose-400" /> para los Eugenialitos
          </p>
          <p className="text-xs text-slate-600">
            © Desarrollado por{' '}
            <a
              href="https://www.linkedin.com/in/csluduena/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-500 hover:text-rose-300 transition-colors"
            >
              @csluduena
            </a>{' '}
            {new Date().getFullYear()}
          </p>
        </div>
      </div>
    </footer>
  );
}
